import type { FeatureCollection, Polygon } from 'geojson';

export const polygons: FeatureCollection<Polygon> = {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      properties: {
        name: 'Caribbean Sea',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-67.537222, 17.310278],
            [-63.988333, 16.996944],
            [-63.978056, 17.083333],
            [-63.965833, 17.193333],
            [-63.932222, 17.505833],
            [-63.919444, 17.618889],
            [-63.914722, 17.661111],
            [-63.889167, 17.943889],
            [-63.898333, 17.964167],
            [-63.950278, 17.979722],
            [-64.017778, 17.999444],
            [-64.041389, 18.003333],
            [-64.265833, 18.034167],
            [-64.335556, 18.041944],
            [-64.352222, 18.041667],
            [-64.450556, 18.0475],
            [-64.493056, 18.048889],
            [-64.634167, 18.050556],
            [-64.649444, 18.1925],
            [-64.661389, 18.278611],
            [-64.660556, 18.289722],
            [-64.637778, 18.318611],
            [-64.637222, 18.320833],
            [-64.6425, 18.344167],
            [-64.637778, 18.356111],
            [-64.639722, 18.364167],
            [-64.670833, 18.365833],
            [-64.683333, 18.372778],
            [-64.700833, 18.370833],
            [-64.707778, 18.373889],
            [-64.716111, 18.373611],
            [-64.726667, 18.375],
            [-64.728333, 18.3775],
            [-64.74, 18.376944],
            [-64.743333, 18.378333],
            [-64.745, 18.3775],
            [-64.755556, 18.376944],
            [-64.776944, 18.386944],
            [-64.783611, 18.405],
            [-64.799167, 18.407778],
            [-64.816667, 18.403056],
            [-64.828056, 18.396667],
            [-64.838056, 18.393333],
            [-64.856389, 18.395],
            [-64.863889, 18.3975],
            [-64.871944, 18.408333],
            [-64.8775, 18.4225],
            [-64.889444, 18.459722],
            [-64.8975, 18.489444],
            [-64.9925, 18.687222],
            [-65.006111, 18.753611],
            [-65.102222, 19.206944],
            [-65.28, 19.507778],
            [-67.445833, 19.187222],
            [-67.537222, 17.310278],
          ],
        ],
      },
      bbox: [-67.537222, 16.996944, -63.889167, 19.507778],
    },
    {
      type: 'Feature',
      properties: {
        name: 'Baltic Sea',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [13.82, 62],
            [13.82, 57.743],
            [10.57, 57.743],
            [10.4, 57.629],
            [9, 55.5],
            [9.3, 54.175],
            [10.5, 53.2],
            [31, 53.2],
            [31, 66.64],
            [18, 66.64],
            [13.82, 62],
          ],
        ],
      },
      bbox: [9, 53.2, 31, 66.64],
    },
    {
      type: 'Feature',
      properties: {
        name: 'Hawaiian Islands',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-153.009167, 22.548333],
            [-153.476667, 23.101389],
            [-154.036667, 23.536389],
            [-154.613333, 23.863056],
            [-155.853611, 24.363611],
            [-156.4575, 24.696389],
            [-157.371389, 24.959167],
            [-157.903611, 25.228056],
            [-158.51, 25.425278],
            [-159.163056, 25.521944],
            [-159.905833, 25.508611],
            [-160.664722, 25.364722],
            [-161.6425, 25.001667],
            [-162.220278, 24.680278],
            [-162.718889, 24.264722],
            [-163.216667, 23.680556],
            [-163.549444, 23.055556],
            [-163.744722, 22.335833],
            [-163.7675, 21.6125],
            [-163.628889, 20.923889],
            [-163.320278, 20.226111],
            [-162.896667, 19.650833],
            [-162.343056, 19.161944],
            [-161.320556, 18.654444],
            [-160.641667, 18.508611],
            [-159.938056, 18.491944],
            [-159.235556, 18.178056],
            [-158.948611, 17.521389],
            [-158.508056, 16.901667],
            [-157.990278, 16.430278],
            [-157.293056, 15.999167],
            [-156.351667, 15.676944],
            [-155.371111, 15.626667],
            [-154.776944, 15.729444],
            [-154.218056, 15.925556],
            [-152.819722, 16.774167],
            [-152.008889, 17.561667],
            [-151.506667, 18.504444],
            [-151.371389, 19.046389],
            [-151.329722, 19.579444],
            [-151.382778, 20.128333],
            [-151.526667, 20.645278],
            [-151.997222, 21.485833],
            [-152.523611, 22.116111],
            [-153.009167, 22.548333],
          ],
        ],
      },
      bbox: [-163.7675, 15.626667, -151.329722, 25.521944],
    },
    {
      type: 'Feature',
      properties: {
        name: 'US East Coast',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-64.16, 60],
            [-74.179688, 49.61071],
            [-101.513672, 49.781264],
            [-101.5, 34.41],
            [-97.146389, 25.956667],
            [-97.139167, 25.956667],
            [-97.085556, 25.961389],
            [-97.031667, 25.966111],
            [-96.978056, 25.970833],
            [-96.924444, 25.975556],
            [-96.808333, 26.009167],
            [-95.6575, 26.008889],
            [-93.564444, 25.998611],
            [-93.066389, 26.295556],
            [-91.880556, 25.861944],
            [-90.784722, 25.744167],
            [-90.494722, 25.781667],
            [-88.55, 25.706944],
            [-87.493056, 26.023333],
            [-86.618611, 26.562778],
            [-86.220833, 26.456111],
            [-86.1125, 26.220278],
            [-86.353889, 25.720833],
            [-86.501944, 25.178889],
            [-85.999722, 24.899167],
            [-85.719722, 24.738056],
            [-85.531667, 24.649167],
            [-85.105278, 24.443611],
            [-84.999722, 24.391667],
            [-84.768611, 24.278056],
            [-84.644167, 24.222222],
            [-84.490833, 24.160278],
            [-83.999722, 23.977222],
            [-83.803056, 23.929722],
            [-83.693056, 23.901111],
            [-83.550278, 23.874167],
            [-83.430278, 23.856111],
            [-83.249722, 23.831111],
            [-82.999722, 23.823333],
            [-82.853056, 23.825556],
            [-82.814722, 23.828333],
            [-82.666389, 23.853889],
            [-82.416389, 23.853889],
            [-82.166389, 23.828333],
            [-82.003056, 23.818056],
            [-81.833056, 23.818056],
            [-81.666389, 23.833889],
            [-81.499722, 23.847778],
            [-81.328611, 23.897778],
            [-81.215278, 23.925556],
            [-81.187778, 24],
            [-81.151389, 24.038889],
            [-81.051667, 24.124444],
            [-81.0325, 24.140556],
            [-81.030833, 24.141667],
            [-81.018611, 24.149444],
            [-80.9975, 24.163333],
            [-80.996389, 24.164167],
            [-80.781667, 24.309722],
            [-80.780278, 24.310556],
            [-80.763056, 24.321111],
            [-80.755833, 24.325278],
            [-80.664167, 24.368611],
            [-80.648889, 24.375833],
            [-80.6025, 24.391667],
            [-80.539444, 24.418611],
            [-80.491667, 24.441667],
            [-80.455556, 24.456389],
            [-80.419444, 24.468333],
            [-80.409722, 24.471667],
            [-80.351389, 24.493889],
            [-80.328889, 24.501667],
            [-80.3225, 24.503889],
            [-80.296389, 24.515833],
            [-80.281944, 24.524167],
            [-80.254444, 24.536944],
            [-80.2225, 24.551389],
            [-80.211944, 24.555],
            [-80.064167, 24.6075],
            [-79.999444, 24.642222],
            [-79.8825, 24.696389],
            [-79.847222, 24.71],
            [-79.827222, 24.717778],
            [-79.823333, 24.738333],
            [-79.765833, 24.924444],
            [-79.746667, 24.984167],
            [-79.734722, 25.008333],
            [-79.715556, 25.05],
            [-79.708056, 25.065278],
            [-79.695833, 25.150833],
            [-79.693333, 25.164167],
            [-79.691944, 25.1775],
            [-79.691944, 25.265833],
            [-79.69, 25.281111],
            [-79.702222, 25.358056],
            [-79.705556, 25.3725],
            [-79.703333, 25.401111],
            [-79.703056, 25.466389],
            [-79.703333, 25.5175],
            [-79.7075, 25.618889],
            [-79.7075, 25.676944],
            [-79.713333, 25.708611],
            [-79.716389, 25.727778],
            [-79.7125, 25.771111],
            [-79.712222, 25.773889],
            [-79.706667, 25.805556],
            [-79.706389, 25.806667],
            [-79.704444, 25.825833],
            [-79.699722, 25.865],
            [-79.696111, 25.89],
            [-79.693889, 25.901111],
            [-79.685, 25.938333],
            [-79.677222, 25.963333],
            [-79.668889, 25.987778],
            [-79.6675, 25.991667],
            [-79.639444, 26.047778],
            [-79.609722, 26.116389],
            [-79.6025, 26.129722],
            [-79.598056, 26.135833],
            [-79.556389, 26.253611],
            [-79.554722, 26.257222],
            [-79.531944, 26.315833],
            [-79.498333, 26.389167],
            [-79.498611, 26.391389],
            [-79.499444, 26.425278],
            [-79.498056, 26.484722],
            [-79.504167, 26.52],
            [-79.510556, 26.569722],
            [-79.512778, 26.580833],
            [-79.513889, 26.589167],
            [-79.518333, 26.608333],
            [-79.525556, 26.636944],
            [-79.533611, 26.686667],
            [-79.538889, 26.727778],
            [-79.539722, 26.741667],
            [-79.544722, 26.762778],
            [-79.574167, 26.899444],
            [-79.5775, 26.921111],
            [-79.588056, 27.007778],
            [-79.588611, 27.099722],
            [-79.582222, 27.198333],
            [-79.571667, 27.270278],
            [-79.527222, 27.433611],
            [-79.476389, 27.882222],
            [-79.189722, 28.286667],
            [-76.669444, 28.286944],
            [-76.8, 28.616389],
            [-76.945, 29.421389],
            [-77.308056, 30.213333],
            [-76.527222, 30.761667],
            [-75.855, 31.054444],
            [-75.255556, 31.453889],
            [-74.200556, 31.920278],
            [-72.901389, 32.758611],
            [-72.286667, 33.323056],
            [-71.876389, 33.913611],
            [-71.617778, 34.552778],
            [-71.433889, 35.582778],
            [-71.566389, 36.540278],
            [-71.1425, 37.310278],
            [-70.630556, 37.879444],
            [-70.4025, 37.963056],
            [-69.568611, 37.970556],
            [-68.781944, 38.091389],
            [-68.033611, 38.322222],
            [-67.349722, 38.654444],
            [-66.809167, 39.031667],
            [-66.353889, 39.473333],
            [-65.9975, 39.968056],
            [-65.885278, 40.095556],
            [-64.991944, 40.129444],
            [-64.143611, 40.292222],
            [-63.180278, 40.615278],
            [-62.296944, 41.081111],
            [-61.234167, 40.762778],
            [-60.205556, 40.6425],
            [-59.088333, 40.693889],
            [-58.048611, 40.926111],
            [-57.086944, 41.339167],
            [-56.159444, 41.971944],
            [-55.528889, 42.67],
            [-55.128056, 43.494722],
            [-54.155556, 43.353889],
            [-53.336944, 43.330556],
            [-52.289444, 43.399722],
            [-51.344722, 43.601667],
            [-50.566944, 43.8875],
            [-49.856389, 44.277222],
            [-49.280556, 44.727222],
            [-48.724444, 45.329167],
            [-48.015, 46.586667],
            [-47.782222, 47.406944],
            [-47.921389, 48.656111],
            [-48.159722, 49.400833],
            [-48.1175, 50.041111],
            [-48.267778, 50.670833],
            [-48.879167, 51.572222],
            [-49.9525, 52.335],
            [-50.168056, 53.083056],
            [-50.121389, 53.748333],
            [-50.295556, 54.389167],
            [-51.828333, 56.303611],
            [-52.391389, 56.8025],
            [-53.132778, 57.238889],
            [-54.016389, 57.586944],
            [-55.063056, 57.847778],
            [-55.634722, 58.900278],
            [-56.716667, 60],
            [-64.16, 60],
          ],
        ],
      },
      bbox: [-101.513672, 23.818056, -47.782222, 60],
    },
    {
      type: 'Feature',
      properties: {
        name: 'US West Coast',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-117.103056, 32.536111],
            [-122, 58.851111],
            [-149.26, 65.07],
            [-155.64, 60.28],
            [-153.250833, 58.851111],
            [-142.815833, 56.621944],
            [-142.288611, 56.475556],
            [-141.605, 56.12],
            [-140.929167, 55.338333],
            [-139.938611, 54.656944],
            [-139.543889, 54.229167],
            [-138.814722, 53.6775],
            [-138.676667, 53.488889],
            [-138.337222, 52.753333],
            [-137.698333, 51.901111],
            [-136.7625, 51.055],
            [-135.316944, 50.031111],
            [-134.264167, 49.3775],
            [-133.246389, 48.963056],
            [-132.683333, 48.542222],
            [-131.261389, 47.665278],
            [-129.074722, 46.565278],
            [-128.816944, 46.183611],
            [-128.667222, 45.511944],
            [-128.689722, 44.411944],
            [-129.023889, 43.439444],
            [-129.095, 42.792778],
            [-129.010556, 42.213611],
            [-128.672778, 41.2275],
            [-128.762778, 40.313056],
            [-128.523056, 39.418056],
            [-127.883333, 38.418889],
            [-127.633889, 37.760833],
            [-127.121667, 37.026389],
            [-126.758333, 36.273611],
            [-126.314722, 35.733333],
            [-125.723056, 35.243889],
            [-125.281111, 34.524444],
            [-124.454167, 33.67],
            [-124.196389, 32.944167],
            [-123.845556, 32.366111],
            [-123.289444, 31.769722],
            [-121.791389, 30.556944],
            [-118.605833, 31.133056],
            [-117.826111, 32.627222],
            [-117.464722, 32.589722],
            [-117.366944, 32.5725],
            [-117.263889, 32.553611],
            [-117.238889, 32.5275],
            [-117.124722, 32.534444],
            [-117.103056, 32.536111],
          ],
        ],
      },
      bbox: [-155.64, 30.556944, -117.103056, 65.07],
    },
    {
      type: 'Feature',
      properties: {
        name: 'North Sea',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-4, 62],
            [-4, 58.324],
            [-5, 57.25],
            [-4, 55.41],
            [-2.36, 55.41],
            [-2.07, 51.18],
            [-4.57, 50.53],
            [-5, 50.2],
            [-5, 48.5],
            [2.241211, 48.502048],
            [7.844238, 47.323931],
            [10.546875, 47.353711],
            [10.5, 53.2],
            [9.3, 54.175],
            [9, 55.5],
            [10.4, 57.629],
            [10.57, 57.743],
            [13.82, 57.743],
            [13.82, 62],
            [-4, 62],
          ],
        ],
      },
      bbox: [-5, 47.323931, 13.82, 62],
    },
    {
      type: 'Feature',
      properties: {
        name: 'China',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [124.168333, 39.828056],
            [122.954, 37.3699],
            [122.95, 37.3581],
            [122.805, 36.8976],
            [122.754, 36.807],
            [122.683, 36.7448],
            [122.41, 36.5858],
            [121.051, 35.7456],
            [120.216, 34.991],
            [121.54, 33.4795],
            [121.854, 33.1053],
            [122.445, 31.5357],
            [123.392, 30.8211],
            [123.41, 30.7644],
            [123.158, 30.0954],
            [122.474, 28.7921],
            [122.125, 28.3162],
            [122.101, 28.2838],
            [121.32, 27.3586],
            [120.708, 26.2924],
            [120.603, 26.0672],
            [120.116, 25.3103],
            [119.624, 24.8255],
            [118.388, 24.015],
            [117.842, 23.3879],
            [117.374, 23.0515],
            [117.331, 23.0258],
            [116.582, 22.7514],
            [115.217, 22.1342],
            [114.036, 21.6174],
            [112.848, 21.3738],
            [112.489, 21.2868],
            [111.45, 19.8661],
            [111.395, 19.7819],
            [110.649, 18.5196],
            [110.628, 18.5067],
            [110.252, 18.2669],
            [110.157, 18.2126],
            [109.759, 17.9842],
            [109.718, 17.9843],
            [109.574, 17.9551],
            [109.061, 18.053],
            [108.845, 18.1496],
            [108.552, 18.3522],
            [108.528, 18.375],
            [108.519, 18.3862],
            [108.479, 18.4263],
            [108.413, 18.8204],
            [108.389, 19.2131],
            [108.379167, 20.401389],
            [108.208611, 21.209722],
            [108.134722, 21.27556],
            [108.095472, 21.452278],
            [108.094111, 21.456417],
            [108.094417, 21.457833],
            [108.097639, 21.460972],
            [108.099361, 21.463917],
            [108.100444, 21.467139],
            [108.101194, 21.470139],
            [108.101194, 21.9],
            [103.579102, 26.94166],
            [103.886719, 32.583849],
            [121.289063, 41.607228],
            [124.168333, 39.828056],
          ],
        ],
      },
      bbox: [103.579102, 17.9551, 124.168333, 41.607228],
    },
    {
      type: 'Feature',
      properties: {
        name: 'Mediterranean Sea',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            // Official Mediterranean ECA boundaries per IMO MARPOL Annex VI Appendix VII

            // Western boundary: Gibraltar Strait entrance (IMO specified coordinates)
            [-6.033333, 36.183333], // Cape Trafalgar, Spain (36°11'.00 N, 6°02'.00 W)
            [-5.916667, 35.8], // Cape Spartel, Morocco (35°48'.00 N, 5°55'.00 W)

            // North African Mediterranean coastline (Morocco to Egypt)
            [-5.54, 33.84],
            [29.55, 26.97],

            // Suez Canal northern entrance with exclusion area (IMO specified coordinates)
            [32.266667, 31.233333], // Point 4: 31°14'.00 N 32°16'.00 E
            [32.266667, 31.483333], // Point 1: 31°29'.00 N 32°16'.00 E
            [32.474667, 31.483333], // Point 2: 31°29'.00 N 32°28'.48 E
            [32.544333, 31.233333], // Point 3: 31°14'.00 N 32°32'.62 E

            // Eastern Mediterranean coastline (Egypt to Turkey)
            [32.49, 30.97],
            [35.74, 30.69],
            [38.02, 38.47],

            // Strait of Canakkale (IMO specified coordinates)
            [26.2, 40.016667], // Kumkale Burnu (40°01'.00 N, 26°12'.00 E)
            [26.183333, 40.05], // Mehmetcik Burnu (40°03'N, 26°11'E)

            // Northern Mediterranean coastline (Turkey to Spain via Europe)
            [26.63, 40.47],
            [27.08, 40.72],
            [15.49, 47.0],
            [3.06, 45.86],

            // Close polygon back to Gibraltar entrance
            [-6.033333, 36.183333],
          ],
        ],
      },
      bbox: [-6.033333, 26.97, 38.02, 47.0],
    },
  ],
};
